// @flow
import * as React from 'react';
import {
    Box,
} from 'grommet';
import permissionRequired from 'esm-web-pro/decorators/permissionRequired';
import ActionComponent from 'esm-web-pro/components/layout/sidePanel/Action';

export type Action = {
    id: string,
    key: string,
    icon: React.Node,
    callback: ?(event: SyntheticMouseEvent<HTMLButtonElement>) => void,
    title?: string,
    tooltip?: string,
    tooltipKey?: string,
    color?: ?string,
    size?: string,
    marginVertical?: string,
    width?: string,
    disabled?: boolean,
    radius?: string,
    opacity?: string,
    loading?: boolean,
}

type Props = {
    actions: Action[],
    iconPadding: string,
    containerPadding?: string | Object,
    wrap?: boolean,
    main: boolean,
}

const Actions = (props: Props) => {
    const {
        actions, iconPadding, main, containerPadding, wrap,
    } = props;

    // If the padding is less than 4px the overflow will be hidden so that no scrollbar appears over the rightmost icon
    return (
        <Box
            direction="row"
            align="center"
            pad={containerPadding || main ? { horizontal: 'xxsmall' } : {}}
            overflow={iconPadding
            && Number(iconPadding.slice(0, iconPadding.indexOf('p'))) < 4 ? 'hidden' : 'auto'}
            wrap={wrap}
            flex={false}
            margin={main ? '12px 0px' : undefined}
        >
            {actions.map((action) => {
                action.marginVertical = '3px';
                const ActionWithPermission = permissionRequired(action.permissions || [])(ActionComponent);
                return <ActionWithPermission key={action.key} {...props} action={action} />;
            })}
        </Box>
    );
};

Actions.defaultProps = {
    iconPadding: '6px',
    containerPadding: undefined,
    main: false,
    wrap: true,
};

export default Actions;
